export const sumPointsByCategory = category => {
  return category.map(reply => {
    const selectReplies = reply.replies.filter(item => item.question.type.name === 'select' && item.value !== null)
    const totalOfValues = selectReplies
      .map(item => Number(item.question.description))
      .reduce((acc, currentValue) => acc + currentValue, 0)
    const totalOfPoints = selectReplies
      .map(item => {
        switch (item.value.name) {
          case 'Conforme':
            return Number(item.question.description)
          case 'Intermediário':
            return Number(item.question.description) / 2
          default:
            return 0
        }
      })
      .reduce((acc, currentValue) => acc + currentValue, 0)

    return { ...reply, totalOfValues, totalOfPoints }
  })
}
